import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Card,
  CardContent,
  Button,
  IconButton,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Paper,
  Avatar,
  Stepper,
  Step,
  StepLabel,
  StepContent,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import SchoolService from "./Locality/Service/schoolService";

import {
  Person,
  School,
  CalendarToday,
  Payment,
  CreditCard,
  AccountBalance,
  PhoneAndroid,
  Receipt,
  CheckCircle,
  Warning,
  Info,ArrowBack,
} from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#f5f5f5",
    minHeight: "100vh",
  },
  header: {
    backgroundColor: "#FFD700",
    color: "#000",
    boxShadow: "none",
  },
  title: {
    fontWeight: "bold",
    fontSize: "1.2rem",
  },
  babyIcon: {
    fontSize: "2rem",
  },
  content: {
    padding: "16px",
    backgroundColor: "#fff",
    margin: "16px",
    marginBottom: "100px", // Add bottom margin to prevent overlap with footer
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  },
  studentInfo: {
    backgroundColor: "#f8f9fa",
    padding: "16px",
    borderRadius: "8px",
    marginBottom: "16px",
  },
  infoRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: "8px",
    "&:last-child": {
      marginBottom: 0,
    },
  },
  infoIcon: {
    marginRight: "12px",
    color: "#666",
    fontSize: "1.2rem",
  },
  infoText: {
    fontSize: "0.9rem",
    color: "#333",
  },
  schoolInfoCard: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    borderRadius: "16px",
    marginBottom: "24px",
    boxShadow: "0 8px 32px rgba(102, 126, 234, 0.3)",
    border: "none",
    overflow: "hidden",
  },
  schoolInfoContent: {
    display: "flex",
    alignItems: "center",
    padding: "20px",
    color: "#fff",
  },
  schoolIconContainer: {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    borderRadius: "50%",
    padding: "12px",
    marginRight: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  schoolIcon: {
    fontSize: "2rem",
    color: "#fff",
  },
  schoolDetails: {
    flex: 1,
  },
  schoolName: {
    fontSize: "1.4rem",
    fontWeight: "bold",
    color: "#fff",
    marginBottom: "4px",
    textShadow: "0 2px 4px rgba(0,0,0,0.3)",
  },
  schoolSubtitle: {
    fontSize: "0.9rem",
    color: "rgba(255, 255, 255, 0.8)",
    fontWeight: "500",
  },
  statusChip: {
    fontWeight: "bold",
    fontSize: "0.8rem",
    padding: "4px 8px",
  },
  dueStatus: {
    backgroundColor: "#ff4444",
    color: "#fff",
  },
  paidStatus: {
    backgroundColor: "#4CAF50",
    color: "#fff",
  },
  installmentCard: {
    marginBottom: "12px",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
  },
  installmentHeader: {
    backgroundColor: "#f5f5f5",
    padding: "12px 16px",
    borderBottom: "1px solid #e0e0e0",
  },
  installmentContent: {
    padding: "16px",
  },
  amount: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "#333",
  },
  dueDate: {
    color: "#666",
    fontSize: "0.9rem",
  },
  payButton: {
    backgroundColor: "#FFD700",
    color: "#000",
    fontWeight: "bold",
    padding: "12px 24px",
    borderRadius: "8px",
    textTransform: "none",
    fontSize: "1rem",
    "&:hover": {
      backgroundColor: "#FFC107",
    },
  },
  paymentDialog: {
    "& .MuiDialog-paper": {
      borderRadius: "12px",
      maxWidth: "500px",
    },
  },
  paymentStep: {
    marginBottom: "16px",
  },
  paymentMethod: {
    display: "flex",
    alignItems: "center",
    padding: "12px",
    border: "2px solid #e0e0e0",
    borderRadius: "8px",
    marginBottom: "8px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": {
      borderColor: "#FFD700",
      backgroundColor: "#fffbf0",
    },
    "&.selected": {
      borderColor: "#FFD700",
      backgroundColor: "#fffbf0",
    },
  },
  paymentIcon: {
    marginRight: "12px",
    color: "#666",
  },
  summaryCard: {
    backgroundColor: "#f8f9fa",
    padding: "16px",
    borderRadius: "8px",
    marginTop: "16px",
  },
  totalAmount: {
    fontSize: "1.8rem",
    fontWeight: "bold",
    color: "#333",
    textAlign: "center",
  },
  footer: {
    backgroundColor: "#FFD700",
    padding: "16px",
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    boxShadow: "0 -2px 8px rgba(0,0,0,0.1)",
  },
  footerButton: {
    backgroundColor: "#FFD700",
    color: "#000",
    fontWeight: "bold",
    padding: "12px 20px",
    borderRadius: "8px",
    textTransform: "none",
    fontSize: "1rem",
    width: "80%",
    "&:hover": {
      backgroundColor: "#FFC107",
    },
  },
}));

export default function PaymentDetailsPage({ 
  student, 
  installment, 
  onBack, 
  onPaymentSuccess 
}) {
  const classes = useStyles();
  const [currentSchool, setCurrentSchool] = useState(null);

  const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [paymentStep, setPaymentStep] = useState(0);
  const [paymentDetails, setPaymentDetails] = useState({
    cardNumber: "",
    expiryDate: "",
    cvv: "",
    name: "",
    upiId: "",
    bankAccount: "",
  });
  useEffect(() => {
    getSchooleRegistrationById();
  }, []);
  const paymentMethods = [
    {
      id: "card",
      name: "Credit/Debit Card",
      icon: <CreditCard />,
      description: "Visa, Mastercard, RuPay",
    },
    {
      id: "upi",
      name: "UPI Payment",
      icon: <PhoneAndroid />,
      description: "Google Pay, PhonePe, Paytm",
    },
    {
      id: "netbanking",
      name: "Net Banking",
      icon: <AccountBalance />,
      description: "Direct bank transfer",
    },
  ];

  const handlePaymentMethodSelect = (methodId) => {
    setSelectedPaymentMethod(methodId);
  };

  const handlePayment = () => {
    setPaymentDialogOpen(true);
  };
  const getSchooleRegistrationById = () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
    const schooleId = userDetails?.schooleId || userDetails?.schooleId || userDetails?.schooleID || student?.schooleId?._id;
    if (!schooleId) {
      console.warn("No school id found in userDetail or student.");
      return;
    }
    SchoolService.getSchooleRegistrationById(schooleId)
      .then((res) => {
        // API returns a single school object
        const school = res?.data || res;
        setCurrentSchool(school);
      })
      .catch((err) => {
        console.error("Error fetching school by id:", err);
      });
  }
  const handlePaymentSubmit = () => {
    // Simulate payment processing
    setTimeout(() => {
      setPaymentDialogOpen(false);
      onPaymentSuccess && onPaymentSuccess(installment);
    }, 2000);
  };

  const getStatusChip = (status) => {
    return (
      <Chip
        label={status}
        className={`${classes.statusChip} ${
          status === "Due" ? classes.dueStatus : classes.paidStatus
        }`}
      />
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return "Not specified";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };


  return (
    <div className={classes.root}>
      {/* Header */}
      <AppBar position="static" className={classes.header}>
        <Toolbar style={{ minHeight: "48px", padding: "0 16px", position: "relative", display: "flex", justifyContent: "center" }}>
          <IconButton edge="start" style={{ position: "absolute", left: 20, paddingRight: 12 }} onClick={onBack}>
            <ArrowBack />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            Payment Details
          </Typography>
        </Toolbar>
      </AppBar>
      <br></br>
      <div className={classes.receiptHeader}>
      <Card className={classes.schoolInfoCard}>
            <div className={classes.schoolInfoContent}>
              <div className={classes.schoolIconContainer}>
                <School className={classes.schoolIcon} />
              </div>
              <div className={classes.schoolDetails}>
                <Typography className={classes.schoolName}>
                  {currentSchool?.schooleName || student?.schooleId?.schoolName || "Montessori School"}
                </Typography>
                <Typography className={classes.schoolSubtitle}>
                  Educational Institution
                </Typography>
              </div>
            </div>
          </Card>
        
        </div>
      {/* Content */}
      <div className={classes.content}>
        {/* Student Information */}
        <div className={classes.studentInfo}>
          <div className={classes.infoRow}>
            <Person className={classes.infoIcon} />
            <Typography className={classes.infoText}>
              <strong>Student:</strong> {student?.fullName || "N/A"}
            </Typography>
          </div>
          <div className={classes.infoRow}>
            <School className={classes.infoIcon} />
            <Typography className={classes.infoText}>
              <strong>Class:</strong> {student?.classId?.className || "N/A"}
            </Typography>
          </div>
          <div className={classes.infoRow}>
            <CalendarToday className={classes.infoIcon} />
            <Typography className={classes.infoText}>
              <strong>Academic Year:</strong> {student?.academicYear || "2024-25"}
            </Typography>
          </div>
          <div className={classes.infoRow}>
            <Receipt className={classes.infoIcon} />
            <Typography className={classes.infoText}>
              <strong>Status:</strong> {getStatusChip(installment?.status || "Due")}
            </Typography>
          </div>
        </div>

        {/* Installment Details */}
        <Card className={classes.installmentCard}>
          <div className={classes.installmentHeader}>
            <Typography variant="h6" style={{ color: "#333", fontWeight: "bold" }}>
              {installment?.label || "Installment Details"}
            </Typography>
          </div>
          <div className={classes.installmentContent}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="body2" color="textSecondary">
                  Amount
                </Typography>
                <Typography className={classes.amount}>
                  ₹{installment?.amount || 0}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" color="textSecondary">
                  Due Date
                </Typography>
                <Typography className={classes.dueDate}>
                  {formatDate(installment?.date)}
                </Typography>
              </Grid>
            </Grid>
            
            {installment?.status === "Due" && (
              <Box mt={2}>
                <Button
                  variant="contained"
                  className={classes.payButton}
                  onClick={handlePayment}
                  fullWidth
                >
                  <Payment style={{ marginRight: "8px" }} />
                  Pay Now
                </Button>
              </Box>
            )}
          </div>
        </Card>

        {/* Payment Summary */}
        <div className={classes.summaryCard}>
          <Typography variant="h6" style={{ marginBottom: "8px", color: "#333" }}>
            Payment Summary
          </Typography>
          <Divider style={{ marginBottom: "12px" }} />
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
            <Typography>Installment Amount:</Typography>
            <Typography>₹{installment?.amount || 0}</Typography>
          </div>
         
          <Divider style={{ marginBottom: "12px" }} />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h6" style={{ fontWeight: "bold" }}>
              Total Amount:
            </Typography>
            <Typography className={classes.totalAmount}>
              ₹{installment?.amount || 0}
            </Typography>
          </div>
        </div>
      </div>

      {/* Payment Dialog */}
      <Dialog
        open={paymentDialogOpen}
        onClose={() => setPaymentDialogOpen(false)}
        className={classes.paymentDialog}
        scroll="paper"
        PaperProps={{
          style: { overflow: 'hidden' }
        }}
      >
        <DialogTitle>
          <Typography variant="h6" style={{ fontWeight: "bold" }}>
            Complete Payment
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Stepper activeStep={paymentStep} orientation="vertical">
            <Step>
              <StepLabel>Select Payment Method</StepLabel>
              <StepContent>
                <div className={classes.paymentStep}>
                  {paymentMethods.map((method) => (
                    <div
                      key={method.id}
                      className={`${classes.paymentMethod} ${
                        selectedPaymentMethod === method.id ? "selected" : ""
                      }`}
                      onClick={() => handlePaymentMethodSelect(method.id)}
                    >
                      <div className={classes.paymentIcon}>{method.icon}</div>
                      <div>
                        <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                          {method.name}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          {method.description}
                        </Typography>
                      </div>
                    </div>
                  ))}
                </div>
              </StepContent>
            </Step>
            
            <Step>
              <StepLabel>Enter Payment Details</StepLabel>
              <StepContent>
                <div className={classes.paymentStep}>
                  {selectedPaymentMethod === "card" && (
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Card Number"
                          placeholder="1234 5678 9012 3456"
                          value={paymentDetails.cardNumber}
                          onChange={(e) => setPaymentDetails({
                            ...paymentDetails,
                            cardNumber: e.target.value
                          })}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          label="Expiry Date"
                          placeholder="MM/YY"
                          value={paymentDetails.expiryDate}
                          onChange={(e) => setPaymentDetails({
                            ...paymentDetails,
                            expiryDate: e.target.value
                          })}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          label="CVV"
                          placeholder="123"
                          value={paymentDetails.cvv}
                          onChange={(e) => setPaymentDetails({
                            ...paymentDetails,
                            cvv: e.target.value
                          })}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Cardholder Name"
                          value={paymentDetails.name}
                          onChange={(e) => setPaymentDetails({
                            ...paymentDetails,
                            name: e.target.value
                          })}
                        />
                      </Grid>
                    </Grid>
                  )}
                  
                  {selectedPaymentMethod === "upi" && (
                    <TextField
                      fullWidth
                      label="UPI ID"
                      placeholder="example@paytm"
                      value={paymentDetails.upiId}
                      onChange={(e) => setPaymentDetails({
                        ...paymentDetails,
                        upiId: e.target.value
                      })}
                    />
                  )}
                  
                  {selectedPaymentMethod === "netbanking" && (
                    <FormControl fullWidth>
                      <InputLabel>Select Bank</InputLabel>
                      <Select
                        value={paymentDetails.bankAccount}
                        onChange={(e) => setPaymentDetails({
                          ...paymentDetails,
                          bankAccount: e.target.value
                        })}
                      >
                        <MenuItem value="sbi">State Bank of India</MenuItem>
                        <MenuItem value="hdfc">HDFC Bank</MenuItem>
                        <MenuItem value="icici">ICICI Bank</MenuItem>
                        <MenuItem value="axis">Axis Bank</MenuItem>
                        <MenuItem value="kotak">Kotak Mahindra Bank</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                </div>
              </StepContent>
            </Step>
          </Stepper>
        </DialogContent>
        <DialogActions style={{ padding: "16px 24px" }}>
          <Button onClick={() => setPaymentDialogOpen(false)}>
            Cancel
          </Button>
          <Button
            variant="contained"
            className={classes.payButton}
            onClick={handlePaymentSubmit}
            disabled={!selectedPaymentMethod}
          >
            Pay ₹{installment?.amount || 0}
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
}
